import { matchPath } from "react-router-dom";

const SHIPPING_ROUTE_BASE = "/stores/:storeId/shipping";
const SHIPPING_SHIPMENT_DETAILS_ROUTE_SUFFIX =
  "/outbound-labels/orders/:orderId";
export const SHIPPING_SHIPMENT_DETAILS_ROUTE = `${SHIPPING_ROUTE_BASE}${SHIPPING_SHIPMENT_DETAILS_ROUTE_SUFFIX}`;

const OUTBOUND_LABEL_STATIC_ROUTES = new Set([
  "about",
  "admin-pick-sessions",
  "bad-warehouse-bins",
  "batch-history",
  "bulk-fulfillments",
  "create-pick-session",
  "dashboard",
  "downloads",
  "eod-manifest",
  "lookup",
  "order-edits",
  "orders",
  "overbox-labels",
  "packing-slips",
  "personalized-inserts",
  "personalized-slips",
  "pick-sessions",
  "pickups",
  "print-jobs",
  "rate-calculator",
  "rewards",
  "scan",
]);

export function isOmsSessionReplayRoute(pathname: string): boolean {
  if (matchPath(SHIPPING_SHIPMENT_DETAILS_ROUTE, pathname)) {
    return true;
  }
  if (
    matchPath(`${SHIPPING_ROUTE_BASE}/outbound-labels/scan`, pathname) ||
    matchPath(
      `${SHIPPING_ROUTE_BASE}/outbound-labels/scan/:fulfillmentGroupId`,
      pathname,
    )
  ) {
    return true;
  }

  const fulfillmentViewMatch = matchPath(
    `${SHIPPING_ROUTE_BASE}/outbound-labels/:viewName`,
    pathname,
  );
  const viewName = fulfillmentViewMatch?.params.viewName;
  return viewName != null && !OUTBOUND_LABEL_STATIC_ROUTES.has(viewName);
}
